import {
  PersonaType,
  CommodityAssignee,
  ProjectMilestoneType,
  CommodityMilestone,
  MilestoneStatusCode,
} from '@bechtel/types';

export type WeldAvatarGroupProps = {
  weldAssignees: CommodityAssignee[];
  personaType?: PersonaType;
  currentMilestoneType?: ProjectMilestoneType;
};

export const FitupMilestoneMock: CommodityMilestone = {
  id: 'fitup-milestone',
  name: 'Fitup',
  hours: 0,
  blocks: [],
  attachments: [],
  weldStatuses: [],
  currentStatus: { codeI18n: MilestoneStatusCode.NOT_APPLICABLE },
};
